import type { AnchorHTMLAttributes } from "react";

export type ButtonLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  variant?: "primary" | "ghost";
};

export function ButtonLink({
  className = "",
  variant = "primary",
  ...rest
}: ButtonLinkProps) {
  const base =
    "inline-flex items-center justify-center rounded-md px-5 py-2.5 text-[calc(0.875rem+0.05vw)] font-medium transition-colors duration-200";
  const ring =
    "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent";
  const styles =
    variant === "primary"
      ? "border border-border-strong bg-accent text-canvas hover:bg-ink hover:text-canvas"
      : "border border-border bg-transparent text-ink hover:border-border-strong hover:text-accent";
  return (
    <a className={`${base} ${ring} ${styles} ${className}`.trim()} {...rest} />
  );
}
